import * as React from 'react';
import { createContext, useContext } from 'react';

import { isAuthenticatedUser } from 'js/lib/user';

import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';

export type CoachCareerFitAssistantContextType = {
  coachCareerFitAssistantEnabled: boolean;
};

export const CoachCareerFitAssistantContext = createContext<CoachCareerFitAssistantContextType>({
  coachCareerFitAssistantEnabled: false,
});

function CoachCareerFitAssistantProvider({ children }: React.PropsWithChildren) {
  const isAuthenticated = isAuthenticatedUser();
  const coachCareerFitAssistantEnabled = isAuthenticated;

  return (
    <CoachCareerFitAssistantContext.Provider
      value={{
        coachCareerFitAssistantEnabled,
      }}
    >
      {coachCareerFitAssistantEnabled ? <CoachStateProvider>{children}</CoachStateProvider> : children}
    </CoachCareerFitAssistantContext.Provider>
  );
}

export const useCoachCareerFitAssistantData = () => {
  return useContext(CoachCareerFitAssistantContext);
};

export default CoachCareerFitAssistantProvider;
